// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"274":"af1a50e5","352":"be43c50d","835":"67a92437"}[chunkId] + ".css";
};